import { Checkbox } from '@/components/ui/checkbox';
import type { GrupoMenu, PermissaoFormulario } from '../types';

interface Props {
  grupo:              GrupoMenu;
  onToggleTudo:       (menuId: number, concederTudo: boolean) => void;
  onAlterarPermissao: (
    formularioId: number,
    campo: keyof Pick<PermissaoFormulario, 'podeLer' | 'podeIncluir' | 'podeEditar' | 'podeExcluir'>,
    valor: boolean
  ) => void;
}

export function TabelaPermissoes({ grupo, onToggleTudo, onAlterarPermissao }: Props) {
  const todosMarcados = grupo.formularios.every(
    f => f.podeLer && f.podeIncluir && f.podeEditar && f.podeExcluir
  );

  return (
    <div className="space-y-1">
      {/* Checkbox "marcar tudo" do módulo */}
      <div className="flex items-center gap-2 border-b pb-3 mb-2">
        <Checkbox
          checked={todosMarcados}
          onCheckedChange={v => onToggleTudo(grupo.menuId, !!v)}
          id={`tudo-${grupo.menuId}`}
        />
        <label
          htmlFor={`tudo-${grupo.menuId}`}
          className="text-sm font-semibold cursor-pointer select-none"
        >
          Marcar / Desmarcar tudo em {grupo.nomeMenu}
        </label>
      </div>

      {/* Cabeçalho */}
      <div className="grid grid-cols-[1fr_90px_90px_90px_90px] gap-2 px-2 pb-1
                      text-xs font-medium text-muted-foreground uppercase tracking-wide">
        <span>Tela</span>
        <span className="text-center">Visualizar</span>
        <span className="text-center">Incluir</span>
        <span className="text-center">Alterar</span>
        <span className="text-center">Excluir</span>
      </div>

      {/* Uma linha por formulário — auto-save ao clicar */}
      {grupo.formularios.map(f => (
        <div
          key={f.formularioId}
          className="grid grid-cols-[1fr_90px_90px_90px_90px] gap-2 items-center
                     px-2 py-1.5 rounded hover:bg-muted/50 text-sm"
        >
          <span className="text-foreground">{f.nomeFormulario}</span>
          {(['podeLer', 'podeIncluir', 'podeEditar', 'podeExcluir'] as const).map(campo => (
            <div key={campo} className="flex justify-center">
              <Checkbox
                checked={f[campo]}
                onCheckedChange={v => onAlterarPermissao(f.formularioId, campo, !!v)}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
